import React from "react";
import Navbar from "./component/Navbar/Navbar";
import Homepage from "./pages/Homepage/Hompage";
import About from "./pages/About/About";
import Projects from "./pages/Projects/Projects";
import Contact from "./pages/Contact/Contact";
import Footer from "./component/Footer/Footer";
import ChatwayWidget from "./component/FloatingChat";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

const App = () => {
  return (
    <div>
      <HelmetProvider>
        <BrowserRouter>
          <Navbar />
          <ChatwayWidget />
          <Routes>
            <Route exact path="/" element={<Homepage />} />
            <Route exact path="/about-me" element={<About />} />
            <Route exact path="/projects" element={<Projects />} />
            <Route exact path="/contact-me" element={<Contact />} />
          </Routes>

          <Footer />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
};

export default App;
